// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2qUsE","title":"Images90_title__DI9LL","images":"Images90_images__GWtBH"};